<template>
  <b-overlay class="img-edit-container" :show="load">
    <center>
      <div
          :style="{
          width: format[0] + 'px',
          height: format[1] + 'px',
        }"
          class="img-edit-preview bg-trans"
          :class="ready ? 'ready' : ''"
      >
        <vue-avatar
            v-if="show"
            :rotation="rotation"
            :width="format[0]"
            :height="format[1]"
            :border="border"
            :scale="scale"
            ref="vueavatar"
            @vue-avatar-editor:image-ready="onImageReady"
            class="vue-avatar"
        />
      </div>
    </center>
    <div class="d-flex justify-content-center align-items-center">
      <div
          style="width: 250px"
          class="d-flex justify-content-center align-items-center flex-column"
      >
        <b-select
            class="mt-3"
            @change="refresh"
            v-model="format"
            :options="formats"
        >
        </b-select>
        <div class="d-flex justify-content-between align-items-top">
          <b-form-group label="Rotation" label-for="rotation" class="mr-2">
            <b-input
                type="range"
                variant="dark"
                :min="0"
                :max="360"
                v-model.number="rotation"
                id="notation"
            />
          </b-form-group>
          <b-form-group label="Zoom" label-for="scale">
            <b-input
                type="range"
                :step="0.01"
                :min="0.1"
                :max="3"
                v-model.number="scale"
                id="scale"
            />
          </b-form-group>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-top">
      <b-form-group
          label="Description de l'image"
          label-for="img-description"
          class="mr-2 mb-0"
      >
        <input-html id="img-description" v-model="meta"/>
      </b-form-group>
      <b-form-group label="Méta-description" label-for="img-meta-description">
        <input-html id="img-meta-description" v-model="alt"/>
      </b-form-group>
    </div>
    <div class="d-flex justify-content-center align-items-center mt-3">
      <b-btn variant="success" size="lg" @click.prevent="saveClicked">
        Enregistrer
      </b-btn>
    </div>
  </b-overlay>
</template>

<script>
import {VueAvatar} from 'vue-avatar-editor-improved';

// https://github.com/fpluquet/vue-avatar-editor

import {http} from '@/http.js';
import inputHtml from './inputHtml.vue';

/**
 * @vuese
 * Modification d'une image
 */
export default {
  name: 'InputImageEdit',
  components: {
    VueAvatar,
    inputHtml
  },
  props: {
    id: {
      type: String,
      default() {
        const rand = Math.random().toString(36).substring(2);
        return 'input-image-edit-' + rand;
      }
    },
    value: {
      type: String,
      default: () => 'default.png'
    },
    width: {
      type: Number,
      default: () => 500
    },
    height: {
      type: Number,
      default: () => 500
    },
    alt: {
      type: String,
      default: () => ''
    },
    meta: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      formats: [
        {
          text: 'Portrait',
          value: [360, 480]
        },
        {
          text: 'Carré',
          value: [500, 500]
        },
        {
          text: 'Paysage',
          value: [888, 500]
        }
      ],
      format: [888, 500],
      load: false,
      show: true,
      rotation: 0,
      scale: 1,
      border: 0,
      ready: false,
      edit: false,
      cropper: false
    };
  },
  methods: {
    refresh() {
      this.$refs.vueavatar.redraw();
    },
    onImageReady() {
      this.ready = true;
    },
    onSaved() {
      this.$emit('saved', this.value);
    },
    saveClicked() {
      const img = this.$refs.vueavatar.getImageScaled();
      const base64 = img.toDataURL();
      this.load = true;

      let dataSend = new FormData();
      dataSend.append('base64', base64);
      dataSend.append('file', this.value);
      dataSend.append('alt', this.alt);

      http.post('media/img', dataSend).then((res) => {
        this.ready = false;
        this.load = false;
        let inputData = {
          src: res.data.file,
          alt: this.alt,
          meta: this.meta
        };
        this.$emit('input', inputData);
        if (this.value === '') {
          this.$emit('created', inputData);
        }
        this.onSaved();
        return res;
      });
    }
  }
};
</script>

<style lang="scss">
.img-edit {
  background-color: var(--border-color);
}

.img-edit-preview {
  overflow: hidden;
  border: 1px solid var(--border-color);
  border-radius: 5px;

  &:not(.ready) {
    background: rgba(var(--border-color), 0.5);
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTQ3MiwzMTIuNjQydjEzOWMwLDExLjAyOC04Ljk3MiwyMC0yMCwyMEg2MGMtMTEuMDI4LDAtMjAtOC45NzItMjAtMjB2LTEzOUgwdjEzOWMwLDMzLjA4NCwyNi45MTYsNjAsNjAsNjBoMzkyICAgIGMzMy4wODQsMCw2MC0yNi45MTYsNjAtNjB2LTEzOUg0NzJ6IiBmaWxsPSIjNTc1NzU3IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxnPgoJCTxwb2x5Z29uIHBvaW50cz0iMjU2LDAuMzU4IDEzMS43MTYsMTI0LjY0MiAxNjAsMTUyLjkyNiAyMzYsNzYuOTI2IDIzNiwzODguNjQyIDI3NiwzODguNjQyIDI3Niw3Ni45MjYgMzUyLDE1Mi45MjYgICAgIDM4MC4yODQsMTI0LjY0MiAgICIgZmlsbD0iIzU3NTc1NyIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgc3R5bGU9IiIgY2xhc3M9IiI+PC9wb2x5Z29uPgoJPC9nPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjwvZz48L3N2Zz4=) !important;
    background-size: 128px 128px;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>